module.exports = __webpack_public_path__ + "static/media/s5-bottom-left.982d9473.png";